import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { SaveSavedFilterRequest } from './types/save-saved-filter-request.type';
import type { SavedFilter } from './types/saved-filter.type';

/**
 * Creates a new saved filter for the current user.
 *
 * @param instance - Ky HTTP instance.
 * @param body - Full saved-filter payload.
 * @returns OperationResultWithData wrapping the persisted `SavedFilter`.
 */
export const createSavedFilter = async (instance: KyInstance, body: SaveSavedFilterRequest) => {
  try {
    return await instance
      .post<OperationResultWithData<SavedFilter>>(Uri.savedFilters.base, {
        json: body,
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
